import React, { useEffect } from "react";
import MiniGamePageHome from "../Home";
import API_PATH from "../../../../config/API_PATH";
import { useParams } from "react-router-dom";
import { useDispatch } from "@pages/Events/MiniGame/store";
import {
  setDataPopupError,
  setOpenPopupGivePiece,
} from "../../../../Redux/futures/mini-game/action";
import { TYPE_GIVE_PIECE } from "../../../../helper/const";
import { getDataApi } from "../../../../config/service";

export default function ComponentInvite() {
  const { awardId: id } = useParams();
  const dispatch = useDispatch();

  const handleCheckParam = async () => {
    const dataGetLink = await getDataApi(
      `${API_PATH.miniGameGetCodeInviteLinkInfo}?code=${id}`
    );

    if (!dataGetLink?.data?.referral || !dataGetLink?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataGetLink?.message || "",
        })
      );
    }
    // show popup confirm invite user
    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        link: "",
        type: TYPE_GIVE_PIECE.confirmInviteUser,
        data: dataGetLink?.data,
      })
    );
  };

  useEffect(() => {
    if (id) {
      handleCheckParam();
    }
  }, [id]);
  return <MiniGamePageHome />;
}
